"use client";

import { Tooltip as RadixTooltip } from "radix-ui";
import type { ComponentPropsWithoutRef, ComponentRef, RefObject } from "react";
import { tv } from "tailwind-variants";

const { Provider, Root, Trigger, Content, Arrow } = RadixTooltip;

const TooltipProvider = Provider;

const Tooltip = Root;

const TooltipTrigger = Trigger;

const TooltipArrow = Arrow;

function TooltipContent({
  ref,
  className,
  sideOffset = 4,
  ...props
}: ComponentPropsWithoutRef<typeof Content> & {
  ref?: RefObject<ComponentRef<typeof Content> | null>;
}) {
  return (
    <Content
      ref={ref}
      sideOffset={sideOffset}
      className={tv({
        base: [
          "z-50 animate-duration-200 animate-fade overflow-hidden rounded-md bg-primary-900 px-5 py-1.5 text-center text-[13px] text-white shadow-md",
          "data-[state=closed]:animate-reverse",
        ],
      })({ className })}
      {...props}
    />
  );
}
TooltipContent.displayName = Content.displayName;

export { Tooltip, TooltipArrow, TooltipContent, TooltipProvider, TooltipTrigger };
